export default __webpack_public_path__ + "static/media/harness_of_tribulation.b07f89cb.jpg";